// Official Google Chat logo (May 2026). Source: https://commons.wikimedia.org/wiki/File:Google_Chat_Logo_05.2026.svg
export function GchatIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 192 192" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="gchat-icon-gradient" x1="96" x2="96" y1="28" y2="124" gradientUnits="userSpaceOnUse">
          <stop offset=".09" stopColor="#94D4FF" />
          <stop offset=".28" stopColor="#78C9FF" />
          <stop offset=".88" stopColor="#01AE58" stopOpacity="0" />
        </linearGradient>
        <mask id="gchat-icon-mask" width="176" height="129" x="8" y="48" maskUnits="userSpaceOnUse" style={{ maskType: "alpha" }}>
          <path
            fill="#0EBC5F"
            d="M133 48c28.167 0 51 22.834 51 51 0 28.167-22.833 51-51 51H96.722l-39.428 25.896c-3.99 2.62-9.294-.242-9.294-5.015V148.81C25.121 143.78 8 123.39 8 99c0-28.166 22.834-51 51-51h74z"
          />
        </mask>
      </defs>
      <rect width="160" height="96" x="16" y="28" fill="#00AF57" rx="48" />
      <path
        fill="#0EBC5F"
        d="M133 48c28.167 0 51 22.834 51 51 0 28.167-22.833 51-51 51H96.624l-34.857 23.064c-3.86 2.544-5.789 3.816-7.372 3.92a6 6 0 0 1-5.612-3.022C48 172.583 48 170.271 48 165.649V148.81C25.121 143.78 8 123.39 8 99c0-28.166 22.834-51 51-51h74z"
      />
      <g mask="url(#gchat-icon-mask)">
        <rect width="160" height="96" x="16" y="28" fill="#0EBC5F" rx="48" />
        <rect width="160" height="96" x="16" y="28" fill="url(#gchat-icon-gradient)" rx="48" />
        <path stroke="#fff" strokeLinecap="round" strokeWidth="12" d="M62 94s8.84 18 34 18 34-17.182 34-17.182" />
      </g>
    </svg>
  );
}
